/** Gamepad standard mapping to player intent (pure). */

export interface PadState {
  axes: readonly number[];
  buttons: readonly boolean[];
}

export interface PadIntent {
  moveX: number;
  moveZ: number;
  aimX: number;
  aimZ: number;
  fire: boolean;
  use: boolean;
  run: boolean;
  crawl: boolean;
  /** ROUND7: the crouched walk, on the left-stick click (L3), which ran before; A still runs. */
  sneak: boolean;
  interact: boolean;
  reload: boolean;
  prevWeapon: boolean;
  nextWeapon: boolean;
  knife: boolean;
  firstAid: boolean;
  recall: boolean;
  map: boolean;
  pause: boolean;
}

export const MOVE_DEAD_ZONE = 0.2;
export const AIM_DEAD_ZONE = 0.25;

/** Convert a raw standard-mapping pad state into a player intent. */
export function readPad(state: PadState): PadIntent {
  const lx = state.axes[0] ?? 0;
  const ly = state.axes[1] ?? 0;
  const rx = state.axes[2] ?? 0;
  const ry = state.axes[3] ?? 0;

  let moveX = 0;
  let moveZ = 0;
  const moveLen = Math.hypot(lx, ly);
  if (moveLen > MOVE_DEAD_ZONE) {
    const scaled = Math.min(1, (moveLen - MOVE_DEAD_ZONE) / (1 - MOVE_DEAD_ZONE));
    moveX = (lx / moveLen) * scaled;
    moveZ = (ly / moveLen) * scaled;
  }

  let aimX = 0;
  let aimZ = 0;
  const aimLen = Math.hypot(rx, ry);
  if (aimLen > AIM_DEAD_ZONE) {
    aimX = rx / aimLen;
    aimZ = ry / aimLen;
  }

  const b = state.buttons;
  return {
    moveX: moveX === 0 ? 0 : moveX,
    moveZ: moveZ === 0 ? 0 : moveZ,
    aimX: aimX === 0 ? 0 : aimX,
    aimZ: aimZ === 0 ? 0 : aimZ,
    fire: b[7] ?? false,
    use: b[6] ?? false,
    run: b[0] ?? false,
    crawl: b[1] ?? false,
    sneak: b[10] ?? false,
    interact: b[2] ?? false,
    reload: b[3] ?? false,
    prevWeapon: b[4] ?? false,
    nextWeapon: b[5] ?? false,
    knife: b[11] ?? false,
    firstAid: b[12] ?? false,
    recall: b[13] ?? false,
    map: b[8] ?? false,
    pause: b[9] ?? false,
  };
}
